import React, { forwardRef, useEffect, useState } from 'react'
import { useDitto } from '@ow/ditto-core'
import Cascader from './Cascader'

const Render = function ({
  opts = {},
  fields,
  errors,
  onChange,
  formControl = {},
}) {
  const { renderType, productSlugs, refSlug, required } = opts
  const { onFetchRemoteData } = useDitto()
  const [tbData, setTbData] = useState([])

  useEffect(() => {
    if (onFetchRemoteData && refSlug) {
      const ditto = onFetchRemoteData(null, refSlug)
      if (ditto) {
        ditto.fetchTbData({ pageSize: 10000 }).then((data) => {
          setTbData(data)
        })
      }
    }
  }, [])

  return (
    <div className="relative flex items-center w-full flex-col">
      {renderType === 'cascader' && (
        <Cascader
          productSlugs={productSlugs}
          fields={fields}
          required={required}
          data={tbData}
          errors={errors}
          formControl={formControl}
          onChange={onChange}
        />
      )}
    </div>
  )
}
export default forwardRef(Render)
